import React, { useEffect } from 'react';

import useUserData, { isCallCenter } from '../../../hooks/useUserData';
import { Helpers } from '../../../core';
import { withError } from '../../../shared/components/error-boundary';

const isNonProd = () => {
    try {
        return window.location.origin.indexOf('www.hp.com') < 0;
    } catch (e) {
        return false;
    }
};

const setLinks = (content, links, loggedIn) => {
    try {
        const {
            mySubscriptionsFormURL,
            manageMyDeviceUrl,
            orderStatusUrl,
            myAccountUrl,
            logonUrl,
            logoutUrl,
            registerUrl,
            personData,
            orderHistoryUrl,
        } = links || {};
        const { email } = personData || {};
        const linksEl = content.querySelectorAll('.sign-in-links .sign-in-link');
        const registerButton = content.querySelector('.create-account-link');
        const signInButton = content.querySelector('.signed-out .sign-in-link');
        const signOutButton = content.querySelector('.sign-out-link');
        const userInfo = content.querySelector('.greeting-name .user-info');
        //create a hidden anchor tag with to prevent error since we are removing the sign-in-link class
        const signInLink = document.createElement('a');
        signInLink.classList.add('sign-in-link');
        signInLink.classList.add('sign-out-link');
        signInLink.href = '';
        signInLink.style.display = 'none';
        content.append(signInLink);
        const myOrderUrl = loggedIn ? orderHistoryUrl : orderStatusUrl;

        if (registerButton) {
            registerButton.href = Helpers.decodeHtml(registerUrl);
        }
        if (signInButton) {
            signInButton.href = Helpers.decodeHtml(logonUrl);
            //remove sign-in-link class
            signInButton.classList.remove('sign-in-link');
        }
        if (signOutButton) {
            signOutButton.href = Helpers.decodeHtml(logoutUrl);
            //remove sign-out-link class
            signOutButton.classList.remove('sign-out-link');
        }
        if (userInfo && email && !userInfo.querySelector('.user-logged-email')) {
            const emailDiv = document.createElement('div');
            emailDiv.classList.add('user-logged-email');
            emailDiv.innerHTML = email;
            emailDiv.style.fontSize = '12px';
            emailDiv.style.lineHeight = '16px';
            userInfo.append(emailDiv);
        }
        linksEl.forEach(link => {
            //find link that contains the word "profile" or has class digitnav-person-icon href to the myAccountUrl
            if (
                (link.innerHTML.toLowerCase().includes('profile') || link.classList.contains('digitnav-person-icon')) &&
                myAccountUrl
            ) {
                link.href = Helpers.decodeHtml(myAccountUrl);
            }
            if (
                (link.innerHTML.toLowerCase().includes('orders') || link.classList.contains('digitnav-cart-icon')) &&
                myOrderUrl
            ) {
                link.href = Helpers.decodeHtml(myOrderUrl);
                link.innerHTML = link.innerHTML.replace('HP.com Orders', 'Orders');
            }
            //find link that includes the word "subscriptions" href to the mySubscriptionsFormURL
            if (
                (link.innerHTML.toLowerCase().includes('subscriptions') ||
                    link.classList.contains('digitnav-plusOpen-icon')) &&
                mySubscriptionsFormURL
            ) {
                link.href = Helpers.decodeHtml(mySubscriptionsFormURL);
            }
            if (
                (link.innerHTML.toLowerCase().includes('devices') ||
                    link.classList.contains('digitnav-devices-icon')) &&
                manageMyDeviceUrl
            ) {
                link.href = Helpers.decodeHtml(manageMyDeviceUrl);
            }
            if (
                link.innerHTML.toLowerCase().includes('security') &&
                link.classList.contains('digitnav-security-icon')
            ) {
                //remove security link
                link.remove();
            }
        });
    } catch (e) {
        console.error('Error adding links to digit sign in template', e);
    }
};

const setSignIn = (header, personData, isccf) => {
    if (!header || !personData.isLoggedIn || (header?.signinInstance?.user && !isccf)) {
        return;
    }

    try {
        const { hpiddata, firstname, lastname } = personData || {};
        //verify that user data is set unless it is a call center user
        const user = (header.signinInstance.user = isccf
            ? undefined
            : {
                  id: hpiddata,
                  name: {
                      givenName: firstname,
                      familyName: lastname,
                  },
              });
        header.signinInstance.showSignedInUI(user);
    } catch (e) {
        console.error('Error adding links to digit sign in template', e);
    }
};

export default withError(({}) => {
    const { userData } = useUserData();
    const { updatedFromService } = userData || {};
    const { profileData } = userData || {};
    const { personData } = profileData || {};
    const isccf = isCallCenter(userData);
    useEffect(() => {
        if (updatedFromService) {
            //check for digit sign in popup and add links
            try {
                const header = document.getElementById('header');
                setSignIn(header, personData, isccf);
                setLinks(document.getElementById('signed-out-template').content, profileData);
                setLinks(document.getElementById('signed-in-template').content, profileData, true);
                header.renderSignIn();
                //add init class to sign in button after all changes, to prevent flicker
                const signInButton = document.querySelector('#header button.sign-in-button');
                if (signInButton) {
                    signInButton.classList.add('init');
                }
                //set site search links to local domain for non-prod
                if (isNonProd() && header?.updateAuthorConfig) {
                    header.updateAuthorConfig({
                        mainBtnUrl: `${document.location.origin}/us-en/shop/sitesearch?keyword=[query]`,
                    });
                }
            } catch (e) {
                console.error('Error rendering sign in', e);
            }
        }

        // remove aria-hidden as it hinders the focus and blur functionality on the cart button
        const el = document.querySelector('.digitnav-cart.cart-portal');
        if (el) {
            el.setAttribute('aria-hidden', false);
        }
        return () => {};
    }, [updatedFromService]);
    useEffect(() => {
        if (isccf) {
            try {
                const signInButton = document.querySelector('#header button.sign-in-button');
                //add disabled class to sign in button
                if (signInButton) {
                    signInButton.classList.add('disabled');
                }
            } catch (e) {}
        }
        return () => {};
    }, [isccf]);
    return null;
});
